import EditWriten  from './EditWriten.vue'
export default EditWriten
